<template>
   <div>
      <PasswordForgot v-if="this.$route.query.id == 1" />
      <PasswordSent  v-if="this.$route.query.id == 2" />
      <PasswordNew  v-if="this.$route.query.id == 3" />
      <PasswordResetSuccess  v-if="this.$route.query.id == 4" />
  </div>
</template>

<script>
import PasswordForgot from '../components/password-forgot'
import PasswordSent from '../components/password-sent'
import PasswordNew from '../components/password-new'
import PasswordResetSuccess from '../components/password-reset-success'

export default {
  name: "PasswordReset",
  components: { PasswordForgot,PasswordSent,PasswordNew ,PasswordResetSuccess},
  
};
</script>

<style lang="scss" scoped></style>
